import { PageConfig } from "../page-configs";
import { AlertId, getAlert } from "../alert";
import { startseiteDZTconfig } from "./welcome-configs/startseite-dzt-config";

export const pageConfigDZT: PageConfig = {
    header: "Digitaler Assistent",
    alert: getAlert(AlertId.StartSeiteBot),
    whitelist: [
        "augsburg/startseite",
        "augsburg/aichach",
        "augsburg/schwabmuenchen",
        "frankfurt-am-main/startseite",
        "sachsen-anhalt-nord/startseite",
        "sachsen-anhalt-nord/burg",
        "sachsen-anhalt-nord/genthin",
        "sachsen-anhalt-nord/haldensleben",
        "sachsen-anhalt-nord/wanzleben",
        "sachsen-anhalt-nord/wolmirstedt",
        "sachsen-anhalt-nord/oschersleben",
        "sachsen-anhalt-nord/stendal",
        "sachsen-anhalt-nord/gardelegen",
        "sachsen-anhalt-nord/osterburg",
        "sachsen-anhalt-nord/salzwedel",
        "essen/startseite",
        "oberhausen/startseite",
        "oberhausen/muelheim-a-d-ruhr",
        "saarland/startseite",
        "saarland/heusweiler",
        "saarland/homburg",
        "saarland/lebach",
        "saarland/merzig",
        "saarland/neunkirchen",
        "saarland/saarlouis",
        "saarland/st-ingbert",
        "saarland/st-wendel",
        "saarland/sulzbach",
        "saarland/voelklingen",
        "saarland/wadern",
        "pirna/startseite",
        "pirna/dippoldiswalde",
        "pirna/freital",
        "pirna/sebnitz",
        "bautzen/startseite",
        "bautzen/goerlitz",
        "bautzen/hoyerswerda",
        "bautzen/kamenz",
        "bautzen/loebau",
        "bautzen/niesky",
        "bautzen/weisswasser",
        "bautzen/zittau",
    ],
    welcome: startseiteDZTconfig,
};
